/**
 * Represents mobile added to cart product quantity
 * @constructor
 */
function MobileCartWidget() {
    this.icon = $('.phone-toggle-menu__link');
    this.counter = $('.cart-count-indicator');
    this.getAjaxQuantity();
}

MobileCartWidget.prototype = {
    get total() {
        return this.counter.val();
    },

    set total(n) {
        this.counter.text(parseInt(n));
        if (!n)
            this.hideIndicator();
        else
            this.showIndicator();
    },

    increase: function (n) {
        var old = parseInt(this.counter.text());
        n = parseInt(n);
        if (n)
            this.counter.text(n + old) && this.showIndicator();
        else {
            this.hideIndicator();
        }
    },

    showIndicator: function () {
        this.counter.addClass('active');
    },

    clear: function () {
        this.counter.text('');
        this.hideIndicator();
    },

    hideIndicator: function () {
        this.counter.removeClass('active');
    },

    getAjaxQuantity: function () {
        var self = this;
        jQuery.ajax('index.php?route=module/cart_head/quantity', {
            type: 'post',
            //dataType: 'html',
            success: function (n) {
                n = parseInt(n);
                self.total = n;
            }
        });
    }
};

module.exports = MobileCartWidget;



// WEBPACK FOOTER //
// ./assets/javascript/mobilecartwidget.js